import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './offer.magic.css.js';
import script from './offer.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[(_vm.background)?_c('div',{staticClass:"background",style:({ backgroundImage: ("url(" + _vm.background + ")") }),attrs:{"part":"background"}}):_vm._e(),_vm._v(" "),(_vm.offer)?_c('magic-ui-box',{staticClass:"box",attrs:{"elevation":"4","part":"box"}},[(_vm.src)?_c('div',{staticClass:"header",attrs:{"part":"header"}},[_c('picture',{staticClass:"picture",attrs:{"part":"picture"}},[_c('source',{attrs:{"type":"image/avif","srcset":_vm.avifSrcset}}),_vm._v(" "),_c('source',{attrs:{"type":"image/webp","srcset":_vm.webpSrcset}}),_vm._v(" "),_c('img',{ref:"header",staticClass:"image",attrs:{"part":"image","loading":"lazy","src":_vm.src,"alt":_vm.offer.content.title}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"inner",attrs:{"part":"inner"}},[_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h2","part":"title","content":_vm.offer.content.title}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"body",attrs:{"is-markdown":"","offer-text":"","part":"body","content":_vm.offer.content.body}}),_vm._v(" "),_c('magic-ui-accordion',{ref:"terms",staticClass:"accordion",attrs:{"no-animation":"","part":"accordion","initially-visible":_vm.showTerms}},[_c('magic-ui-text',{staticClass:"title title--tnc",attrs:{"slot":"toggle","tag":"h3","part":"title title--tnc","content":_vm.offer.tnc.title},slot:"toggle"}),_vm._v(" "),_c('magic-ui-text',{staticClass:"body body--tnc",attrs:{"slot":"content","is-markdown":"","tag":"div","part":"body body--tnc","content":_vm.offer.tnc.body},slot:"content"})],1),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},_vm._l((_vm.offer.cta),function(cta){return _c('magic-ui-button',{key:cta.id,staticClass:"button",attrs:{"wide":"","button-tag":"a","variant":"primary","part":"button","href":cta[_vm.magicConfig.mobile ? 'mobile' : 'desktop']},domProps:{"innerHTML":_vm._s(cta.text)},on:{"click":function($event){return _vm.onCtaClick(cta)}}})}),1)],1)]):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-64e98df8_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-64e98df8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
